module.exports = __webpack_public_path__ + "static/media/thumnail_bhir_gauthali_option.dfd4bfca.png";